<template>
    <section class="select-a-dealer" id="selectADealer">
        <div class="select-a-dealer__container container">
            <StepBar />

            <StepLink :step="2" />

            <div class="select-a-dealer__columns">
                <div class="select-a-dealer__search-box">
                    <h3 class="select-a-dealer__search-box-title">Search for your dealer</h3>
                    <DealerLookup :inputNullable="true" placeholder="Search by postcode" @postcodeSearch="updatePostcodeSearch" @place-updated="handlePlaceUpdate" />
                </div>


                <template v-if="postcodeSearch == 1">
                    <div is="transition-group" name="fade" class="select-a-dealer__dealer-card-grid">
                        <DealerCard v-for="dealer in closestDealers" :key="dealer.id" :dealer="dealer" @select="selectDealer" :takata-recall-dealers="takataRecallFixDealers" />
                    </div>

                    <div class="load-more__container">
                        <a @click.prevent="incrementDealersToShow" v-if="showLoadMoreLink" class="load-more__link">Load more ...</a>
                    </div>
                </template>
                <div v-else>
                    <div class="select-a-dealer__help-container">
                        <img src="/images/info.svg" alt="" class="select-a-dealer__help-icon" />
                        <p class="select-a-dealer__help-text">Enter your town/postcode above and choose your address from the list in order to find your nearest dealership</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { StepBar, StepLink } from "../";
import DealerLookup from "../DealerLookup.vue";
import EventObject from '../../../modules/tracking/EventObject';
import GetBrandFromManufacturer from "../../../used-vue/api/GetBrandFromManufacturer";
import DealerCard from './DealerCard.vue';

export default {
    components: {
        DealerLookup,
        StepBar,
        StepLink,
        DealerCard,
    },

    props: {
        vauxhallTakataRecallFix: {
            type: Boolean,
            default: false,
            required: false
        },
    },

    data() {
        return {
            dealersToShow: 3,
            postcodeSearch: 0,
        };
    },

    computed: {
        ...mapState("OSB", ["brand", "selectedVehicle", "registration", "mileage"]),
        ...mapState("Dealers", ["dealers", "selectedDealer"]),

        takataRecallFixDealers() {
            if (!this.vauxhallTakataRecallFix) {
                return [];
            }

            return this.dealers.filter((dealer) => {
                return dealer.offers_servicing === "Y" && dealer.brand.toLowerCase() === 'peugeot' && (
                    dealer.name.includes("Chingford") ||
                    dealer.name.includes("Romford") ||
                    dealer.name.includes("Maidstone") ||
                    dealer.name.includes("Guildford")
                );
            }).map(dealer => dealer.id);
        },

        filteredDealers() {
            if (this.brand !== "") {
                return this.dealers.filter((dealer) => {
                    return (dealer.offers_servicing === "Y" && dealer.brand.toLowerCase() === this.brand.toLowerCase()) || this.takataRecallFixDealers.includes(dealer.id);
                });
            }

            if (window.brand && window.brand !== "") {
                return this.dealers.filter((dealer) => {
                    return (dealer.offers_servicing === "Y" && dealer.brand.toLowerCase() === window.brand.toLowerCase()) || this.takataRecallFixDealers.includes(dealer.id);
                });
            }

            if (this.selectedVehicle && typeof this.selectedVehicle.make !== "undefined" && this.selectedVehicle.make !== "") {
                const brand = GetBrandFromManufacturer(this.selectedVehicle.make);
                if (brand !== 'randd') {
                    return this.dealers.filter((dealer) => {
                        return (dealer.offers_servicing === "Y" && dealer.brand.toLowerCase() === this.selectedVehicle.make.toLowerCase()) || this.takataRecallFixDealers.includes(dealer.id);
                    });
                }
            }

            return this.dealers.filter((dealer) => {
                return (dealer.offers_servicing === "Y") || this.takataRecallFixDealers.includes(dealer.id);
            });
        },

        closestDealers() {
            return this.filteredDealers.slice(0, this.dealersToShow);
        },

        showLoadMoreLink() {
            return this.closestDealers.length < this.filteredDealers.length;
        },
    },

    methods: {
        ...mapMutations("Dealers", ["setSelectedDealer"]),
        ...mapMutations("OSB", ["incrementStep"]),

        selectDealer(dealer) {
            new EventObject('OSB', 'Click', 'Select this dealer clicked').dispatch();
            this.setSelectedDealer(dealer);
            this.$emit('collect-pricing');
            window.scrollTo(0, 0);
            this.incrementStep();
        },

        incrementDealersToShow() {
            this.dealersToShow += 3;
        },

        updatePostcodeSearch(value) {
            this.postcodeSearch = value;
        },

        handlePlaceUpdate(place) {
            this.$emit('place-updated', place);
        }
    },
};
</script>
